import {
  FETCH_RECENT_DESTINATIONS,
  FETCH_RECENT_DESTINATIONS_SUCCESS,
} from "../store/types";
import store from '../store/store';

export const fetchRecentDestinations = () => (dispatch) => {
  dispatch({ type: FETCH_RECENT_DESTINATIONS });

  const bookings = store.getState().bookinglistdata.bookings;
  const userInfo = store.getState().auth.profile;

  if (!bookings || !userInfo) {
    dispatch({
      type: FETCH_RECENT_DESTINATIONS_SUCCESS,
      payload: []
    });
    return;
  }

  // Filter completed bookings for this customer
  const completed = bookings.filter(b =>
    b.status === 'COMPLETE' && b.customer === userInfo.uid && b.drop && b.drop.add
  );

  // Extract unique destinations (by address string), most recent first
  const seen = new Set();
  const destinations = [];
  for (const booking of completed) {
    const key = booking.drop.add.trim().toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      destinations.push({
        lat: booking.drop.lat,
        lng: booking.drop.lng,
        description: booking.drop.add,
        lastUsed: booking.bookingDate,
        category: booking.category,
        place_id: null
      });
    }
    if (destinations.length >= 10) break;
  }

  dispatch({
    type: FETCH_RECENT_DESTINATIONS_SUCCESS,
    payload: destinations
  });
};
